import React, { useState, useEffect, useRef } from "react";
import FlexBetween from "../../components/FlexBetween";
import ReactDOM from "react-dom";

import { useToast } from "../../services/utils";
import {
  Box,
  Grid,
  Input,
  IconButton,
  Button,
  Tooltip,
  Backdrop,
  CircularProgress,
  NativeSelect,
  Tabs,
  Tab,
} from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import FileUploadButton from "../../components/Uploaders/FileUpload";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { manageAvailableColumns } from "../../services/utils";
import {
  buildAdditionalResourceColumnInfo,
  mergeResourceColumnsWithMetadata,
} from "../../services/utils/mergeResourceColumns";
import DataTable from "../../components/DataGrids/DataGrid";
import {
  datatypes,
  dateTimeFormat,
  severity_level,
} from "../../services/constants";

import DerivedColumnDialog from "../../components/Dialogs/DerivedColumnDialog";
import ReferenceDialog from "../../components/Dialogs/ReferenceDialog";
import ValidationDialog from "../../components/Dialogs/ValidationDialog";
import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF } from "@mui/x-data-grid-pro";
import {
  defaultResourceCDMColumns,
  resourceCDMColumns,
} from "../../services/constants/resource";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useResourceContext } from "../../contexts/ResourceContext";
import ConfirmDailog from "../../components/Dialogs/ConfirmDailog";

import CheckboxWithKeyboardEvent from "../../components/Molecules/Resource/CheckboxWithKeyboardEvent";

import { useRuleResourceContext } from "../../contexts/RuleResourceContext";
import CrossFieldValidations from "../../pages/ResourceColumns/CrossFieldValidations";
import {
  IconAddRowBase,
  IconDeleteBlueSvg,
  IconEditBase,
  IconPlusBase,
} from "../../common/utils/icons";
import { useRowsPerPage } from "../../hooks/useRowsPerPage";
import ValidationScoringConfigForm from "../../components/Scoring/ValidationScoringConfigForm";

interface AddResourceColumnsProps {
  useResourceColumns?: any;
  crossFieldValidations?: any;
  setCrossFieldValidations?: any;

  currentDomainType?: any;
  domainsTableData?: any;

  selectedDomain?: any;
  onScoringConfigChange?: (values: any) => void;
  onScoringConfigValidityChange?: (isValid: boolean) => void;
}

const AddResourceColumnsTable: React.FC<AddResourceColumnsProps> = ({
  crossFieldValidations,
  setCrossFieldValidations,
  domainsTableData,

  selectedDomain,

  currentDomainType,
  onScoringConfigChange,
  onScoringConfigValidityChange,
}: AddResourceColumnsProps) => {
  const {
    setIsDailogEdit,
    setDailogEditIndex,
    // SetCDMColumns,
    setSelectedRowId,
    setOpenValidationDialog,
    resourceColumnFileData,
    setResourceColumnFileData,
    setPageContext,
    formData,
    setFormData,

    errors,
    setErrors,
    crossFieldErrors,
    setCrossFieldErrors,
    setOpenDerivedColumnDialog,
    setDerivedModalType,
    setOpenReferenceDialog,
    setReferenceData,
    allResourcesAdditionalData,
    resourceColumns,
  } = useResourceContext();
  const {
    availColumns,
    setAvailColumns,
    setAvailColumnsWithResourceDetail,

    setQueryBuilderTempValue,
  } = useRuleResourceContext();
  const defaultPage = process.env.REACT_APP_DEFAULT_PAGE;
  const [page, setPage] = useState<number>(
    defaultPage ? parseInt(defaultPage) : 1
  );
  const { rowsPerPage } = useRowsPerPage();
  const [pSize, setPSize] = useState<number>(rowsPerPage);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  const [currentType, setCurrentType] = useState<any>("existing");
  const [backdropLoading, setBackdropLoading] = useState(true);
  const [expandedRow, setExpandedRow] = useState<any>([]);

  const [isDailogOpen, setIsDailogOpen] = useState(false);
  const [allVariablesList, setAllVariablesList] = useState({
    resource: {},
    resourceColumn: {},
    additionalResource: {},
    baseResource: {},
  });

  const [oldColumnName, setOldColumnName] = useState("");
  const [activeTab, setActiveTab] = useState<string>("resourceColumns");

  useEffect(() => {
    setResourceColumnFileData([defaultResourceCDMColumns]);
    setPageContext("resourceColumn");
    setBackdropLoading(false);
  }, []);
  // hooks

  const { showToast } = useToast();

  const prepareAvailableColumnsForQueryBuilder = () => {
    const baseColumns = resourceColumnFileData.map(
      (item: any) => item?.column_name
    );

    if (
      formData?.additional_resource_data?.length > 0 &&
      allResourcesAdditionalData?.length > 0 &&
      resourceColumns?.length > 0
    ) {
      const resourceColumnIds = formData.additional_resource_data.map(
        (res: any) => res.resource_id
      );
      const updatedColumnsData = resourceColumnIds.map((res_id: any) => {
        const resource_column_ids = allResourcesAdditionalData?.find(
          (res1: { id: number }) => res1.id === res_id
        )?.additional_properties?.resource_column_details_id;

        const resource_column = (resourceColumns as any)?.find(
          (res1: { id: number }) => res1.id === resource_column_ids
        )?.resource_column_properties?.resource_columns;
        return {
          resource_id: res_id,
          resource_columns: resource_column,
        };
      });

      const additionalResourceColumnInfo = buildAdditionalResourceColumnInfo(
        formData.additional_resource_data,
        allResourcesAdditionalData,
        updatedColumnsData
      );

      const structuredColumns = mergeResourceColumnsWithMetadata(
        baseColumns,
        additionalResourceColumnInfo,
        allResourcesAdditionalData
      );
      setAvailColumns(structuredColumns);
    } else {
      setAvailColumns(baseColumns);
    }
    setAvailColumnsWithResourceDetail(null);
  };

  const handleAddValidation = (id: any) => {
    prepareAvailableColumnsForQueryBuilder();
    setSelectedRowId(id);
    setOpenValidationDialog(true);
  };
  const handleEditValidationDialog = (id: any, index: number) => {
    prepareAvailableColumnsForQueryBuilder();
    setOpenValidationDialog(true);
    setIsDailogEdit(true);
    setSelectedRowId(id);
    setDailogEditIndex(index);
  };
  const handleDeleteValidation = (index: number, rowId: number) => {
    const currentIndex = resourceColumnFileData.findIndex(
      (item: any) => item.id === rowId
    );
    const updatedData = resourceColumnFileData[
      currentIndex
    ].custom_validations.filter((item: any, i: number) => i !== index);
    setResourceColumnFileData((prev: any) => {
      const newData = prev.map((item: any) => {
        if (item.id === rowId) {
          item.custom_validations = updatedData;
        }
        return item;
      });
      return newData;
    });
  };
  const handleEditReferenceDialog = (
    id: any,
    connectionKeys: any,
    linkedServices: any
  ) => {
    const currentIndex = resourceColumnFileData.findIndex(
      (item: any) => item.id === id
    );
    const referenceData = {
      source:
        resourceColumnFileData[currentIndex].reference_column_definition.source,
      source_type:
        resourceColumnFileData[currentIndex].reference_column_definition
          .source_type,
      use_translation:
        resourceColumnFileData[currentIndex].reference_column_definition
          .use_translation,
      connection_key: connectionKeys.find(
        (connectionKey: any) =>
          connectionKey?.id ===
          resourceColumnFileData[currentIndex].reference_column_definition
            ?.connection_key
      ),
      linked_service: linkedServices.find(
        (linkedServices: any) =>
          linkedServices?.id ===
          resourceColumnFileData[currentIndex].reference_column_definition
            ?.linked_service_id
      ),
      inline_variables:
        resourceColumnFileData[currentIndex].reference_column_definition
          ?.inline_variables,
    };
    setOpenReferenceDialog(true);
    setSelectedRowId(id);
    setReferenceData(referenceData);
  };
  const handleDeleteReference = (rowId: number) => {
    setResourceColumnFileData((prev: any) => {
      return prev.map((item: any) => {
        if (item.id === rowId) {
          item.is_reference = false;
          item.reference_column_definition = null;
        }
        return item;
      });
    });
  };
  const handleAddMoreRow = () => {
    let newRow = { ...resourceCDMColumns };
    const highestId = resourceColumnFileData.reduce(
      (maxId: any, item: any) => Math.max(maxId, item.id),
      -1
    );
    newRow.id = highestId + 1;
    const updatedData = [...resourceColumnFileData, newRow];
    setResourceColumnFileData(updatedData);
    const newTotalRows = updatedData.length;
    const maxRowsPerPage = pSize;
    const newPageIndex = Math.floor((newTotalRows - 1) / maxRowsPerPage);
    setTimeout(() => {
      setPage(newPageIndex + 1);
      setTimeout(() => {
        const lastInput = inputRefs.current[updatedData.length - 1];
        if (lastInput) {
          const domNode = ReactDOM.findDOMNode(lastInput);
          if (domNode instanceof HTMLElement) {
            domNode?.focus();
          }
        }
      }, 700);
    }, 300);
  };
  const handleDeleteAllRows = () => {
    if (resourceColumnFileData && resourceColumnFileData.length > 0) {
      setIsDailogOpen(true);
    }
  };
  const handleCancelDeleteAction = () => {
    setIsDailogOpen(false);
  };
  const handleConfirmDeleteAction = () => {
    setIsDailogOpen(false);
    setResourceColumnFileData([resourceColumnFileData[0]]);
    setAvailColumns([]);
    setAvailColumnsWithResourceDetail(null);
  };

  const handleChangeTab = (event: any, newValue: any) => {
    if (newValue === "crossFieldValidations") {
      prepareAvailableColumnsForQueryBuilder();
    }
    setActiveTab(newValue);
  };

  // Define table column names
  const columns: GridColDef[] = [
    {
      ...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
      renderCell: (params: any) => (
        <IconButton
          size="small"
          tabIndex={-1}
          disabled={
            params?.row?.is_derived ||
            params?.row?.custom_validations?.length > 0 ||
            params?.row?.is_reference ||
            params?.row?.reference_column_definition != null
              ? false
              : true
          }
          onClick={() => {
            // toggle in array
            if (expandedRow.includes(params.row.id)) {
              setExpandedRow((prev: any) =>
                prev.filter((item: any) => item !== params.row.id)
              );
            } else {
              setExpandedRow((prev: any) => [...prev, params.row.id]);
            }
          }}
        >
          {params?.row?.is_derived ||
          params?.row?.custom_validations?.length > 0 ||
          params?.row?.is_reference ||
          params?.row?.reference_column_definition != null ? (
            <ExpandMoreIcon
              sx={{
                transform: `rotateZ(${
                  expandedRow.includes(params.row.id) ? 180 : 0
                }deg)`,
                transition: (theme) =>
                  theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shortest,
                  }),
              }}
              fontSize="inherit"
            />
          ) : null}
        </IconButton>
      ),
    },
    {
      field: "column_name",
      headerName: "Resource Column",
      width: 120,
      minWidth: 150,
      flex: 1,
      renderCell: (params: any) => {
        const handleFocusIn = (e: React.FocusEvent<HTMLInputElement>) => {
          setOldColumnName(e.target.value);
        };
        const handleOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
          const updatedColumns = resourceColumnFileData
            .filter((item: any) => item.column_name !== "file_name")
            .map((item: any) => item.column_name);
          setAvailColumns(updatedColumns);
          setAvailColumnsWithResourceDetail(null);
        };
        const valueField = resourceColumnFileData.find(
          (item: any) => item.id === params.row.id
        )?.column_name;
        const isNameFilled = valueField !== "";
        const handleChangeName = (e: any) => {
          const value = e.target.value;
          if (value.toLowerCase() === "file_name") {
            const isFileNameExist = resourceColumnFileData.some(
              (fileItem: any) =>
                fileItem.column_name.toLowerCase() === "file_name"
            );
            if (isFileNameExist) {
              showToast(
                `"file_name" is reserved key column, and already exist, please provide different name.`,
                "warning"
              );
              return;
            }
          }
          setResourceColumnFileData((prev: any) => {
            const newData = prev.map((item: any) => {
              if (item.id === params.row.id) {
                item.column_name = value;
              }
              return item;
            });
            return newData;
          });
        };

        return (
          <Tooltip title={valueField} placement="top">
            <input
              ref={(el) => (inputRefs.current[params?.id] = el)}
              // placeholder="Ex: Sample Column Name"
              value={
                resourceColumnFileData.find(
                  (item: any) => item.id === params.row.id
                )?.column_name
              }
              onChange={handleChangeName}
              className={`form-control-1  input-ellipsis ${
                !isNameFilled ? "border-red" : ""
              }`}
              onKeyDown={(e: any) => {
                e.stopPropagation();
              }}
              onBlur={handleOnBlur}
              onFocus={handleFocusIn}
            />
          </Tooltip>
        );
      },
    },
    {
      field: "domain_column",
      headerName: "Domain Column",
      width: 120,
      minWidth: 130,
      flex: 1,
      renderCell: (params) => {
        const handleChange = (event: any) => {
          const value = event.target.value;
          setResourceColumnFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                item.domain_column = value;
              }
              return item;
            })
          );
        };

        const menuData =
          currentDomainType === "existing"
            ? selectedDomain?.domain_properties?.columns || []
            : domainsTableData || [];

        const filterMenuData = menuData.filter(
          (item: any) => item.name !== "file_name"
        );
        return (
          <Tooltip title={params.value} placement="top">
            <NativeSelect
              value={
                params.value && typeof params.value === "string"
                  ? params.value.trim()
                  : params.value || ""
              }
              className="white-space-nowrap form-control capitalize"
              onChange={handleChange}
            >
              <option key={"Select..."} value={""}>
                Select...
              </option>
              {filterMenuData?.length > 0 &&
                filterMenuData.map((domainColumnItem: any) => {
                  return (
                    <option
                      key={domainColumnItem?.name}
                      value={domainColumnItem?.name}
                    >
                      {domainColumnItem?.name}
                    </option>
                  );
                })}
            </NativeSelect>
          </Tooltip>
        );
      },
    },
    {
      field: "datatype",
      headerName: "Data Type",
      width: 100,
      renderCell: (params) => {
        const dataTypeValue = resourceColumnFileData.find(
          (item: any) => item.id === params.row.id
        )?.datatype;
        const isDataTypeFilled = dataTypeValue !== "" && dataTypeValue !== null;
        const handleChange = (event: any) => {
          const value = event.target.value;
          setResourceColumnFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                item.datatype = value;
                item.data_format = "";
                // Clear column_length when datatype is changed to non-string
                if (value !== "string") {
                  item.column_length = null;
                }
              }
              return item;
            })
          );
        };

        return (
          <NativeSelect
            value={
              params?.value && typeof params.value === "string"
                ? params.value.trim()
                : params?.value || ""
            }
            className={`white-space-nowrap format-arrow-pos capitalize ${
              !isDataTypeFilled ? "border-red-parent" : ""
            }`}
            onChange={handleChange}
          >
            <option key={"Select..."} value={""}>
              Select...
            </option>
            {datatypes.map((typeItem) => (
              <option key={typeItem} value={typeItem}>
                {typeItem}
              </option>
            ))}
          </NativeSelect>
        );
      },
    },
    {
      field: "is_mandatory",
      headerName: "Mandatory",
      maxWidth: 90,
      align: "center",
      renderCell: (params) => {
        const cellValue =
          params.value && typeof params.value === "string"
            ? params.value.trim()
            : params.value;
        const handleChange = (event: any) => {
          const value = event.target.checked;
          setResourceColumnFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                item.is_mandatory = value;
              }
              return item;
            })
          );
        };

        return (
          <CheckboxWithKeyboardEvent
            handleChange={handleChange}
            params={params}
          />
        );
      },
    },
    {
      field: "is_masking",
      headerName: "Masking",
      maxWidth: 90,
      align: "center",
      renderCell: (params) => {
        const handleChange = (event: any) => {
          const value = event.target.checked;
          setResourceColumnFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                item.is_masking = value;
              }
              return item;
            })
          );
        };

        return (
          <CheckboxWithKeyboardEvent
            handleChange={handleChange}
            params={params}
          />
        );
      },
    },
    {
      field: "key",
      headerName: "Key",
      maxWidth: 60,
      align: "center",
      renderCell: (params) => {
        const cellValue =
          params.value && typeof params.value === "string"
            ? params.value.trim()
            : params.value;
        const handleChange = (event: any) => {
          const value = event.target.checked;
          setResourceColumnFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                item.key = value;
                if (params.row.is_active !== true && item.key === true) {
                  item.is_active = true;
                }
              }
              return item;
            })
          );
        };

        return (
          <CheckboxWithKeyboardEvent
            handleChange={handleChange}
            params={params}
          />
        );
      },
    },
    {
      field: "is_reference",
      headerName: "Reference",
      description: "Reference Data",
      maxWidth: 90,
      align: "center",
      renderCell: (params) => {
        const handleChange = (event: any) => {
          const value = event.target.checked;
          if (value) {
            setOpenReferenceDialog(value);
            setSelectedRowId(params.row.id);
            setReferenceData({
              source: "internal",
              source_type: "",
              use_translation: false,
            });
          } else {
            setResourceColumnFileData((prev: any) =>
              prev.map((item: any) => {
                if (item.id === params.row.id) {
                  item.is_reference = value;
                  item.reference_column_definition = null;
                }
                return item;
              })
            );
          }
        };
        return (
          <CheckboxWithKeyboardEvent
            handleChange={handleChange}
            params={params}
          />
        );
      },
    },
    {
      field: "is_active",
      headerName: "Act./Inac.",
      maxWidth: 70,
      align: "center",
      renderCell: (params) => {
        const cellValue =
          params.value && typeof params.value === "string"
            ? params.value.trim()
            : params.value;
        const handleChange = async (event: any) => {
          const value = event.target.checked;

          const isTruthy = ["Y", "y", "Yes", "yes", true, "true"].includes(
            params.row.key
          );
          if (params.row.is_active === true && isTruthy) {
            showToast(
              `If you want to uncheck 'Active/Inactive,' please uncheck the 'Key' column first.`,
              "warning"
            );
            return;
          }
          // Extract flat array for manageAvailableColumns (backward compatibility)
          const flatColumns = Array.isArray(availColumns)
            ? availColumns
            : (availColumns as any)?.flatColumns || [];

          const updatedColumns = manageAvailableColumns(
            flatColumns,
            params.row.column_name,
            "toggle"
          );
          setAvailColumns(updatedColumns);
          setAvailColumnsWithResourceDetail(null);
          setResourceColumnFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                item.is_active = value;
              }
              return item;
            })
          );
        };

        return (
          <CheckboxWithKeyboardEvent
            handleChange={handleChange}
            params={params}
          />
        );
      },
    },
    {
      field: "column_length",
      headerName: "Length",
      width: 100,
      renderCell: (params) => {
        const handleChange = (event: any) => {
          const value = event.target.value;
          setResourceColumnFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                // item.column_length = parseInt(value, 10);
                const parsedValue = parseInt(value, 10);
                item.column_length = isNaN(parsedValue) ? null : parsedValue;
              }
              return item;
            })
          );
        };

        // Disable length field for non-string datatypes
        const isDisabled = params.row.datatype !== "string";

        return (
          <Input
            // placeholder="Ex: Sample Length"
            value={(
              resourceColumnFileData
                ?.find((item: any) => item.id === params.row.id)
                ?.column_length?.toString() || ""
            ).replace(/ /g, "")}
            onChange={handleChange}
            onKeyDown={(e: any) => {
              e.stopPropagation();
            }}
            disabled={isDisabled}
            className="form-control input-ellipsis"
          />
        );
      },
    },
    {
      field: "severity_level",
      headerName: "Severity",
      width: 100,
      renderCell: (params) => {
        const severityLevelValue = resourceColumnFileData
          .find((item: any) => item.id === params.row.id)
          ?.severity_level?.toLowerCase();
        const handleChange = (event: any) => {
          const value = event.target.value as string;
          setResourceColumnFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                return { ...item, severity_level: value };
              }
              return item;
            })
          );
        };

        return (
          <NativeSelect
            value={severityLevelValue}
            className="white-space-nowrap capitalize"
            onChange={handleChange}
            style={{ width: "100%", height: 35 }}
            placeholder="Select..."
          >
            {severity_level.map((severity: string) => (
              <option key={severity} value={severity}>
                {severity}
              </option>
            ))}
          </NativeSelect>
        );
      },
    },
    {
      field: "data_format",
      headerName: "Format",
      width: 120,
      minWidth: 120,
      flex: 1,
      renderCell: (params) => {
        const cellValue =
          params.value && typeof params.value === "string"
            ? params.value.trim()
            : params.value;
        const handleChange = (event: { target: { value: any } }) => {
          const value = event.target.value;
          setResourceColumnFileData((prev: any) =>
            prev.map((item: any) => {
              if (item.id === params.row.id) {
                item.data_format = value;
              }
              return item;
            })
          );
        };

        return (
          <>
            {!(
              resourceColumnFileData.find(
                (item: any) => item.id === params.row.id
              )?.datatype === "datetime"
            ) ? (
              <Input
                // placeholder="Ex: Sample Enter Format"
                value={
                  resourceColumnFileData?.find(
                    (item: any) => item.id === params.row.id
                  )?.data_format || ""
                }
                onChange={handleChange}
                onKeyDown={(e: any) => {
                  e.stopPropagation();
                }}
                className="form-control input-ellipsis"
              />
            ) : (
              <Tooltip
                title={dateTimeFormat.includes(cellValue) ? cellValue : ""}
                placement="top"
                arrow
              >
                <NativeSelect
                  value={dateTimeFormat.includes(cellValue) ? cellValue : ""}
                  className={`white-space-nowrap format-arrow-pos form-control ${
                    !dateTimeFormat.includes(params.value)
                      ? "border-red-parent"
                      : ""
                  }`}
                  style={{ width: "100%", height: 35 }}
                  onChange={handleChange}
                >
                  <option key={"Select..."} value={""}>
                    Select...
                  </option>
                  {dateTimeFormat.map((format: string, index: number) => (
                    <option key={format + index} value={format}>
                      {format}
                    </option>
                  ))}
                </NativeSelect>
              </Tooltip>
            )}
          </>
        );
      },
    },
    {
      field: "action",
      headerName: "Actions",
      align: "center",
      headerAlign: "center",
      width: 165,
      renderCell: (params) => {
        const handleDelete = () => {
          setResourceColumnFileData((prev: any) =>
            prev.filter((item: any) => item.id !== params.row.id)
          );
          const flatAvailColumns = Array.isArray(availColumns)
            ? availColumns
            : (availColumns as any)?.flatColumns || [];
          const updatedColumns = manageAvailableColumns(
            flatAvailColumns,
            params.row.column_name,
            "remove"
          );
          setAvailColumns(updatedColumns);
          setAvailColumnsWithResourceDetail(null);
        };

        const handleAddNewRow = () => {
          let newRow = { ...resourceCDMColumns };
          const currentRowIdx = resourceColumnFileData.findIndex(
            (item: any) => item.id === params.row.id
          );
          const highestId = resourceColumnFileData.reduce(
            (maxId: any, item: any) => Math.max(maxId, item.id),
            -1
          );
          newRow.id = highestId + 1;
          const updatedData = [...resourceColumnFileData];
          updatedData.splice(currentRowIdx + 1, 0, newRow);
          setResourceColumnFileData(updatedData);
        };

        return (
          <>
            <Tooltip title="Add Validation" placement="top" arrow>
              <IconButton
                color="inherit"
                onClick={() => {
                  handleAddValidation(params.row.id);
                  //updateCDMColumns();
                }}
                className="datagrid-action-btn"
              >
                {/* <AddOutlined /> */}
                <IconPlusBase />
              </IconButton>
            </Tooltip>
            {params.row.is_derived && (
              <Tooltip title="Edit Derived Column" placement="top" arrow>
                <IconButton
                  color="inherit"
                  onClick={() => {
                    // onAddDerivedColumn();
                    prepareAvailableColumnsForQueryBuilder();
                    setOpenDerivedColumnDialog(true);
                    setDerivedModalType("edit");
                    setSelectedRowId(params.row.id);
                  }}
                  className="datagrid-action-btn"
                >
                  <IconEditBase />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title="Add Column" placement="top" arrow>
              <Button
                color="secondary"
                onClick={handleAddNewRow}
                className="datagrid-action-btn min-width-40"
              >
                <IconAddRowBase />
              </Button>
            </Tooltip>
            <Tooltip title="Delete Row" placement="top" arrow>
              <IconButton
                color="inherit"
                onClick={handleDelete}
                className="datagrid-action-btn"
              >
                <IconDeleteBlueSvg />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  // handel event when we save a resource

  const onAddDerivedColumn = () => {
    prepareAvailableColumnsForQueryBuilder();
    setDerivedModalType("add");
    setOpenDerivedColumnDialog(true);
    setSelectedRowId(null);
    setQueryBuilderTempValue("");
    //updateCDMColumns();
  };

  if (backdropLoading)
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );

  const tabContent: any = {
    resourceColumns: (
      <Box>
        <FlexBetween gap="3rem" sx={{ marginTop: "-20px" }}>
          <DataTable
            dataColumns={columns}
            dataRows={resourceColumnFileData}
            checkboxSelection={false}
            dataListTitle="Resource Info"
            buttonText="Derived Column"
            buttonClass="btn-orange btn-dark btn-sm"
            buttonClick={onAddDerivedColumn}
            buttonIcon={<AddCircleOutlineIcon />}
            className="dataTable no-radius table-focused"
            handleEditValidationDialog={handleEditValidationDialog}
            handleDeleteValidation={handleDeleteValidation}
            handleEditReferenceDialog={handleEditReferenceDialog}
            handleDeleteReference={handleDeleteReference}
            handleAddMoreRow={handleAddMoreRow}
            handleDeleteAllRows={handleDeleteAllRows}
            paginationModel={{
              page: page - 1,
              pageSize: pSize,
            }}
            onPaginationModelChange={(params: any) => {
              if (params.pageSize !== pSize || params.page !== page - 1) {
                setPage(params.page + 1);
                setPSize(params.pageSize);
              }
            }}
            isPaginationChangeRequiredOnClientSide={true}
          />
        </FlexBetween>
      </Box>
    ),
    crossFieldValidations: (
      <CrossFieldValidations
        crossFieldValidations={crossFieldValidations}
        setCrossFieldValidations={setCrossFieldValidations}
        isViewOnly={false}
        errors={crossFieldErrors}
        setErrors={setCrossFieldErrors}
      />
    ),
    scoringConfig: (
      <Box sx={{ marginTop: "-20px" }}>
        <ValidationScoringConfigForm
          resourceId={0}
          existingConfig={null}
          onSaveSuccess={() => {}}
          hideCreateButton={true}
          onValuesChange={onScoringConfigChange}
          onValidityChange={onScoringConfigValidityChange}
        />
      </Box>
    ),
  };

  return (
    <Box>
      <Grid
        container
        rowSpacing={2.5}
        columnSpacing={{ xl: 4, lg: 3, md: 2, sm: 2, xs: 1 }}
        justifyContent="space-between"
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <>
            <Tabs
              sx={{
                mt: 1,
              }}
              value={activeTab}
              onChange={handleChangeTab}
              className="mui-tabs alternative-1"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Resource Columns" value="resourceColumns" />
              <Tab label="Adhoc Query" value="crossFieldValidations" />
              <Tab label="Scoring Config" value="scoringConfig" />
            </Tabs>
            <Box>{tabContent[activeTab]}</Box>
          </>
        </Grid>
      </Grid>

      <ValidationDialog setAllVariablesList={setAllVariablesList} />
      <DerivedColumnDialog setAllVariablesList={setAllVariablesList} />
      <ReferenceDialog setAllVariablesList={setAllVariablesList} />

      <ConfirmDailog
        isDailogOpen={isDailogOpen}
        handleCancelAction={handleCancelDeleteAction}
        handleConfirmAction={handleConfirmDeleteAction}
        dailogTitle={"Confirm Delete"}
        dailogDescription={
          "This action will delete all rows, still want to continue?"
        }
      />
    </Box>
  );
};

export default AddResourceColumnsTable;
